export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hoodie_Metalness.e44554ad.tga";